.calendarGrid {
  --ixf-calendar-grid-cell-height: 2rem;
  --ixf-calendar-grid-cell-min-width: 2rem;
  --ixf-calendar-grid-cell-font-size: 0.875rem;
  --ixf-calendar-grid-cell-line-height: 0.875rem;
  --ixf-calendar-grid-cell-font-weight: var(--ixf-font-weight-main-medium);

  .weekDayHeading {
    align-items: center;
    justify-content: center;
    background: var(--ixf-calendar-grid-cell-background);
    height: var(--ixf-calendar-grid-cell-height);
    min-width: var(--ixf-calendar-grid-cell-min-width);
    border-radius: var(--ixf-calendar-grid-cell-border-radius);
    font-size: var(--ixf-calendar-grid-cell-font-size);
    line-height: var(--ixf-calendar-grid-cell-line-height);
    font-weight: var(--ixf-calendar-grid-cell-font-weight);
    color: var(--ixf-calendar-grid-cell-font-color);
    user-select: none;

    .content {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
  }

  .weekRow {
    &:not(:last-child) {
      > td {
        padding-bottom: var(--ixf-space-2);
      }
    }
  }
}
